import { Timestamp } from 'firebase/firestore'
import { object, string, nonempty, boolean, instance } from 'superstruct'
export function useFilterSchemas() {
  function getComplexFilterSchema() {
    return { complex: true, values: [], operator: 'AND', days_ago: null }
  }

  function getSimpleFilterSchema() {
    return {
      field: '',
      complex: false,
      type: 'text',
      values: [],
      operator: 'IN',
      days_ago: null
    }
  }

  /**
   * @typedef {Object} Filter
   * @property {string} name - The name of the Filter.
   * @property {string} [description] - Optional description of the Filter.
   * @property {Object} filter - Filter values, using a complex filter schema.
   * @property {Object} sort - Sort values for organizing Filter items.
   * @property {boolean} private - Indicates if the Filter is private. Defaults to true.
   * @property {string|null} updated_by - User ID of the last user to edit the Filter.
   * @property {string|null} id - Unique ID of the Filter, generated by the filesystem (FS).
   * @property {Timestamp} created - Timestamp when the Filter was created.
   * @property {string|null} created_by - User ID of the owner of the Filter.
   * @property {Timestamp} updated - Timestamp when the Filter was last updated.
   * @property {string|null} updated_by - User ID of the last user to update the Filter.
   */

  function getFilterManagerSchema() {
    return {
      name: '',
      description: '',
      filter: getComplexFilterSchema(),
      sort: {},
      private: true,

      id: null,
      created: null,
      created_by: null,
      updated: null,
      updated_by: null
    }
  }

  const filterSchema = object({
    name: nonempty(string()),
    description: string(),
    filter: object(),
    sort: object(),
    private: boolean(),

    id: string(),
    created: instance(Timestamp),
    created_by: string(),
    updated: instance(Timestamp),
    updated_by: string()
  })

  return {
    getFilterManagerSchema,
    getComplexFilterSchema,
    getSimpleFilterSchema,
    filterSchema
  }
}
